import { render, staticRenderFns } from "./bugReports.vue?vue&type=template&id=0d556c2d&scoped=true&"
import script from "./bugReports.vue?vue&type=script&lang=js&"
export * from "./bugReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d556c2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d556c2d')) {
      api.createRecord('0d556c2d', component.options)
    } else {
      api.reload('0d556c2d', component.options)
    }
    module.hot.accept("./bugReports.vue?vue&type=template&id=0d556c2d&scoped=true&", function () {
      api.rerender('0d556c2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deviceMgr/components/bugReports.vue"
export default component.exports